import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPartModelsOverview } from '../../../store/Slices/PartModelSlice';
import Stats from '../../../components/Stats';
import { activeStatsIcon, lateStatsIcon, tripStatsIcon } from '../../../utils/svgs';

const PartModelOverviewCards = () => {
    const dispatch = useDispatch();
    const { partModelsOverview, partModelsOverviewLoading } = useSelector((state) => state.partModels);

    useEffect(() => {
        dispatch(getPartModelsOverview());
    }, [dispatch]);

    const statsData = [
        {
            title: 'Total Part Models',
            value: partModelsOverview?.total || 0,
            text: 'Total number of part models',
            icon: tripStatsIcon,
            className: 'total'
        },
        {
            title: 'Active',
            value: partModelsOverview?.active || 0,
            text: 'Active part models',
            icon: activeStatsIcon,
            className: 'completed'
        },
        {
            title: 'Inactive',
            value: partModelsOverview?.inactive || 0,
            text: 'Inactive part models',
            icon: lateStatsIcon,
            className: 'late'
        }
    ];

    if (partModelsOverviewLoading && !partModelsOverview) {
        return (
            <div className="stats_main_div skeleton-loader" style={{ height: '100px', marginBottom: '20px' }}>
                {/* Skeleton state */}
            </div>
        );
    }

    return (
        <Stats statsData={statsData} numberOfColumn={4} />
    );
};

export default PartModelOverviewCards;
